import MovementsTab from './MovementsTab'

export default MovementsTab
